import {useLocation} from "react-router-dom";
import React, {useRef} from "react";
import { ModernWebLayout, MainContent } from "../../components/Layout";
import TableOfContentsSideMenu from "../../components/TableOfContents/TableOfContentsSideMenu";
import ModernMainContent from "./ModernMainContent";
import {useTableOfContentsScroll} from "../../hooks/tableOfContentsHooks/useTableOfContentsScroll";
import AppTopicBanner from "../../components/AppTopicBanner/AppTopicBanner";
import useScreenSize from "../../hooks/useScreenSize";

const ModernApp = ({}) => {
  const { pathname, search, hash } = useLocation();
  const contentRef = useRef(null);
  useTableOfContentsScroll(contentRef);
  const {isDesktop, isTabletSize} = useScreenSize();

  return (
    <ModernWebLayout
      title="Guidelines - Therapeutic Guidelines"
      stickyPageSidebar={
        <TableOfContentsSideMenu msPath={`${search}${hash ? hash : ""}`} />
      }
      stickyPageHeader={
        (!isDesktop || isTabletSize) && (
          <AppTopicBanner pathname={pathname} search={search} hash={hash} />
        )
      }
      showSidebar={isDesktop}
    >
      <MainContent padding="none" className={"webMode"}>
        {isDesktop && !isTabletSize && (
          <AppTopicBanner pathname={pathname} search={search} hash={hash} />
        )}
        <ModernMainContent ref={contentRef} />
      </MainContent>
    </ModernWebLayout>
  );
};

export default ModernApp;